import React, { useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import { GET_IMAGE_SBOM } from '../graphql/queries';
import { DataTable } from '../components/DataTable';

const componentColumns = [
  {
    accessorKey: 'name',
    header: 'Component',
    cell: ({ getValue }) => <code style={{ fontSize: 12 }}>{getValue()}</code>,
  },
  {
    accessorKey: 'version',
    header: 'Version',
    cell: ({ getValue }) => <code style={{ fontSize: 12 }}>{getValue()}</code>,
  },
  {
    accessorKey: 'type',
    header: 'Type',
    cell: ({ getValue }) => (
      <span className="badge badge-info" style={{ fontSize: 11 }}>{getValue()}</span>
    ),
  },
  {
    accessorKey: 'purl',
    header: 'Package URL',
    cell: ({ getValue }) => getValue() ? (
      <span style={{ fontSize: 11, color: '#636e72', maxWidth: 300, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', display: 'block' }}>
        {getValue()}
      </span>
    ) : '-',
  },
  {
    accessorKey: 'licenses',
    header: 'License',
    cell: ({ getValue }) => {
      const licenses = getValue();
      if (!licenses || licenses.length === 0) return '-';
      return licenses.join(', ');
    },
  },
];

export default function SBOMViewer() {
  const { imageId } = useParams();
  const [format, setFormat] = useState('cyclonedx');
  const [search, setSearch] = useState('');

  const { data, loading, error } = useQuery(GET_IMAGE_SBOM, {
    variables: { imageId, format },
  });

  if (loading) return <div className="loading">Loading SBOM...</div>;
  if (error) return <div className="error">Failed to load SBOM: {error.message}</div>;

  const sbom = data?.getImageSBOM;
  if (!sbom) {
    return (
      <div>
        <h2 className="page-title">SBOM Viewer</h2>
        <div className="card" style={{ textAlign: 'center', padding: 40 }}>
          <p style={{ color: '#636e72' }}>No SBOM found for this image. SBOMs are generated during the build process.</p>
          <Link to={`/images/${imageId}`} className="btn btn-primary" style={{ marginTop: 16 }}>Back to Image</Link>
        </div>
      </div>
    );
  }

  const filtered = search
    ? sbom.components.filter(c =>
        c.name.toLowerCase().includes(search.toLowerCase()) ||
        (c.purl && c.purl.toLowerCase().includes(search.toLowerCase()))
      )
    : sbom.components;

  return (
    <div>
      <h2 className="page-title">SBOM Viewer</h2>

      <div className="card">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
          <div>
            <h3 style={{ margin: 0 }}>Software Bill of Materials</h3>
            <p style={{ margin: '4px 0 0', fontSize: 13, color: '#636e72' }}>
              {sbom.componentCount} components | Format: {sbom.format.toUpperCase()} | Generated: {sbom.generatedAt ? new Date(sbom.generatedAt).toLocaleString() : 'N/A'}
            </p>
          </div>
          <div style={{ display: 'flex', gap: 8 }}>
            <select
              value={format}
              onChange={(e) => setFormat(e.target.value)}
              style={{ padding: '6px 12px', borderRadius: 6, border: '1px solid #dfe6e9', fontSize: 13 }}
            >
              <option value="cyclonedx">CycloneDX</option>
              <option value="spdx">SPDX</option>
            </select>
            {sbom.downloadUrl && (
              <a href={sbom.downloadUrl} className="btn btn-primary" style={{ fontSize: 13, padding: '6px 16px' }} download>
                Download
              </a>
            )}
          </div>
        </div>

        <input
          type="text"
          placeholder="Search components..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          style={{ width: '100%', padding: '8px 12px', borderRadius: 6, border: '1px solid #dfe6e9', marginBottom: 12, fontSize: 13 }}
        />

        <DataTable columns={componentColumns} data={filtered} pageSize={20} />
      </div>

      <div className="actions">
        <Link to={`/images/${imageId}`} className="btn btn-primary">Back to Image</Link>
        <Link to={`/scorecard/${imageId}`} className="btn btn-primary" style={{ background: '#00b894' }}>Health Scorecard</Link>
      </div>
    </div>
  );
}
